import { paymentService } from '@/features/subscription/services/paymentService';
import { NextUI } from '@/components/NextUI';
import Button from '@/components/NextUI/Button';
import usePaddlePricing from '@/features/subscription/hooks/usePaddlePricing';
import { useAppDispatch } from '@/hooks/redux';
import { hideModal } from '@/store/slices/modalSlice';
import { showToast } from '@/store/slices/toastActions';
import { Spinner } from '@heroui/spinner';
import React from 'react';
import { usePlan } from '@/features/subscription/hooks/usePlan';
import { useTranslations } from 'next-intl';
import { useAppSelector } from '@/hooks/redux';
import { RootState } from '@/store';

function UpgradeAnnual() {
  const t = useTranslations('modals.upgrade_annual');
  const { yearlyPrices, isLoadingPrices } = usePaddlePricing();
  const { plan, refreshData } = usePlan();
  const dispatch = useAppDispatch();
  const typeForUserAccessLevel = useAppSelector(
    (state: RootState) => state.userAccess.typeForUserAccessLevel
  );
  const [isUpgradeLoading, setIsUpgradeLoading] = React.useState(false);
  const handleUpgradeToYearly = async () => {
    try {
      if (!plan) {
        throw new Error(t('messages.missing_subscription'));
      }
      const priceId = yearlyPrices.find(
        (price) => price.trial_period === null && price.quantity.maximum === 1
      )?.id;
      if (!priceId) {
        throw new Error(t('messages.error'));
      }
      setIsUpgradeLoading(true);
      await paymentService.upgradeSubscription({
        priceId,
        paywallType: typeForUserAccessLevel || 'in_app',
      });

      dispatch(
        showToast({
          text: t('messages.success'),
          variant: 'success',
        })
      );

      await refreshData();

      // setTimeout(() => {
      //   // window.location.reload();
      // }, 1000);
    } catch (error) {
      console.error(error);
      dispatch(
        showToast({
          text: t('messages.error'),
          variant: 'danger',
        })
      );
    } finally {
      dispatch(hideModal());
      setIsUpgradeLoading(false);
    }
  };

  return (
    <NextUI.Modal
      className="max-w-[500px]"
      classNames={{ content: 'py-8 !px-4 md:!px-8' }}
      defaultOpen={true}
      name={'UpgradeAnnual'}
    >
      <div className="flex flex-col items-start justify-start w-full">
        <span className="text-2xl font-semibold text-dark">{t('title')}</span>

        <p className="text-gray-medium text-[17px] mt-6">{t('description1')}</p>

        <p className="text-gray-medium text-[17px] mt-6">{t('description2')}</p>

        <div className="flex justify-end gap-4 mt-8 w-full">
          <Button
            variant="outline"
            onClick={() => dispatch(hideModal())}
            className="w-[160px]"
          >
            {t('buttons.cancel')}
          </Button>
          {isLoadingPrices || isUpgradeLoading ? (
            <div className={'flex justify-center'}>
              <Spinner />
            </div>
          ) : (
            <>
              <Button className="w-[160px]" onClick={handleUpgradeToYearly}>
                {t('buttons.upgrade')}
              </Button>
            </>
          )}
        </div>
      </div>
    </NextUI.Modal>
  );
}

export default UpgradeAnnual;
